import { createFileRoute } from '@tanstack/react-router'
import { Building2 } from 'lucide-react'
import { OrgSettingsScreen } from '@/screens/org/SCR-140-settings'

export const Route = createFileRoute('/_app/org/settings')({
  staticData: { screen: { id: 'SCR-140', title: 'Organisation settings', group: 'Organisation', perm: 'identity.manage', pin: true, order: 1, description: 'Name, logo, sign-in policy, verified domains, ownership and closing the organisation.', icon: Building2 } },
  component: OrgSettingsScreen,
})
